import i18n from '@/i18n';

function createRelanceLibelle(relance) {
  relance.relanceLibelle = i18n.t('relance.relanceMaj') + ' ' + relance.numRelance
    + ' - ';
  if (relance.libelle === undefined) {
    relance.relanceLibelle += relance.mouvementsClientIds.length > 1
      ? relance.payeur.nomCommercial : relance.mouvementsClients[0].libelle;
  } else {
    relance.relanceLibelle += relance.libelle;
  }
}

function createActionLibelle(relance) {
  let numProchaineRelance = relance.numRelance + 1;
  if (numProchaineRelance > 3) numProchaineRelance = 3;

  relance.actionLibelle = (numProchaineRelance) + i18n.t('relance.eme');
}

function creationLibelleDetail(relance) {
  relance.libelleDetail = relance.numRelance;
  if (relance.numRelance === 1) {
    relance.libelleDetail += i18n.t('relance.ere') + ' ' + i18n.t('relance.relanceMin');
  } else {
    relance.libelleDetail += i18n.t('relance.eme') + ' ' + i18n.t('relance.relanceMin');
  }
}

export default function ajoutLibelleRelance(items) {
  items.forEach((relance) => {
    if (relance.numRelance !== 0) {
      createRelanceLibelle(relance);
      createActionLibelle(relance);
      creationLibelleDetail(relance);
    } else {
      relance.relanceLibelle = relance.libelle;
      relance.actionLibelle = i18n.t('relance.newRelance');
    }
    relance.selected = false;
  });
  return items;
}
